<template>
    <div class="home" v-loading="loading">
        <div class="swiper-slide">
            <div class="page">
                <div class="productIntro" v-if="language == 'ZH'">
                    <p>铁马高尔夫 · 关于我们</p>
                    <p>铁马高尔夫深耕多元高尔夫核心业务，涵盖全球高尔夫场地预订、国内外旅游、会籍代理、高尔夫赛事策划与执行、高尔夫用品线上线下商城、广告公关传媒等全链条服务商。</p>
                    <p>2004年，铁马高尔夫于深圳正式启航，自此深耕高尔夫服务领域，稳步前行，步步深耕。</p>
                    <p>2007年挺进北京，2009年落子上海，2012年进驻广州、南下海南。</p>
                    <p>2017年，铁马高尔夫加速全国战略布局，湖南、云南、湖北、重庆、山东、四川等多地分公司与办事处相继落地，每一步前行，皆为离用户更近。</p>
                    <p>历经多年深耕沉淀，目前铁马高尔夫已布局全国12家分公司、25家线下高尔夫专卖店，构建起覆盖全方位服务网络。</p>
                    <p>同时，铁马高尔夫设立深圳、北京、上海三大客服中心，全天候贴心值守，快速响应每一位用户的需求。依托自有专业技术团队，自主研发铁马高尔夫APP、小程序及智能管理系统，以数字化赋能，让每一位客户的预订、购物都更从容、便捷。
                    </p>
                    <p>2025年，铁马高尔夫签约知名职业高尔夫球手隋响担任品牌形象大使，以职业专业力量赋能品牌升级。依托全国完善的服务网点、客服中心、数字化服务系统，搭配全国近400名铁马员工团队，构建起全方位、高效率的一站式高尔夫服务保障体系，让"响到哪，就订哪"不再是简单的标语，而是每一位球友挥杆出行背后实打实的服务底气，团队时刻待命、全程护航，为每一位球友精准指路、全心服务。
                    </p>
                    <p>铁马APP与小程序，凭借优质的服务体验，覆盖率与活跃度稳居国内高尔夫服务类应用前列。</p>
                    <p>凭借专业的服务实力，铁马年度球场预订量超70万轮次，国内外高尔夫旅游送客量超5万人次，年均承办超300场大型商业赛事，行业服务经验深厚、实力备受认可。</p>
                    <p>铁马高尔夫旗下拥有正规出入境资质的自营旅行社——重庆丁丁猫国际旅行社。合法合规的跨境出行保障，以及深耕海外高尔夫多年的服务团队，为球友的每一次出行保驾护航。海外行程遍布欧、美、澳、新、日、韩及中东、非洲、东南亚等30多个国家和地区，让全球畅打无后顾之忧。
                    </p>
                    <p>铁马高尔夫始终坚守高品质的服务标准，匠心定制每一段挥杆旅程，同时推出了行业史上第一本实体印刷版的《高尔夫旅游地图指南》手册，为每一位高球爱好者的环球挥杆梦想精准引路，助力球友驰骋全球、打卡世界百佳球场。
                    </p>
                    <p>向世界挥杆，从铁马出发。</p>
                    <p>"响"到哪，就订哪！</p>
                </div>
                <div class="productIntro" v-else>
                    <p class="font-bold">About CHINA TEMA GOLF</p>
                    <p>CHINA TEMA GOLF is China's preeminent one-stop golf services provider, headquartered in Shenzhen. Founded in 2004, we bring <span class="font-bold">22 years of specialized industry expertise</span> to golf enthusiasts worldwide, having evolved into the nation's most comprehensive full-chain golf services group with a robust global service network.</p>
                    <p>Our integrated business ecosystem spans premier global tee-time reservations, bespoke golf travel, omnichannel retail operations, membership brokerage, professional tournament planning, and media &amp; advertising solutions. With an unrivaled domestic footprint, we operate <span class="font-bold">12 regional branches</span> and <span class="font-bold">25 golf pro shops</span> across China, serving over <span class="font-bold">95% of all golf courses</span> in the country. Our proprietary TEMA GOLF App leads the Chinese golf category in download volume, powering more than <span class="font-bold">700,000 annual global tee-time bookings.</span> We employ over 380 dedicated professionals, including 200+ on-site sales specialists stationed at 50 major golf courses nationwide, ensuring unparalleled market coverage and responsive customer support. Each year, we serve more than 50,000 golf travelers globally and host over 300 large-scale commercial tournaments, solidifying our undisputed leadership in China's golf industry.</p>
                    <p class="font-bold">Your Trusted Partner for Golf in China</p>
                    <p>China boasts hundreds of world-class golf destinations, from sun-drenched tropical resort courses in Hainan and dramatic mountain layouts in Yunnan to exclusive urban clubs in Beijing, Shanghai, Guangzhou, and Shenzhen—each offering a distinctive and unforgettable golfing experience.</p>
                    <p>CHINA TEMA GOLF provides professional, <span class="font-bold">fully compliant one-stop inbound golf services</span> for international golfers. We own and operate <span class="font-bold">Chongqing TTM International Travel Agency,</span> a government-licensed inbound and outbound travel provider with full legal authorization to arrange cross-border travel. This official qualification guarantees the highest standards of safety, reliability, and legal protection for all our international clients.</p>
                    <p class="font-bold">Our comprehensive inbound services include:</p>
                    <p>Visa application assistance and documentation support</p>
                    <p><span class="font-bold">Multilingual tour guides</span> (covering English, Japanese, Korean, and other major languages)</p>
                    <p>Seamless airport transfers and ground transportation</p>
                    <p>Luxury hotel and resort bookings</p>
                    <p>Fully personalized golf itineraries tailored to your preferences</p>
                    <p>With our extensive local knowledge, licensed travel credentials, and round-the-clock assistance, we ensure a completely seamless and worry-free golf experience in China.</p>
                    <p>Beyond China, our global services extend to over 30 countries and regions across Europe, North America, Australia, New Zealand, Japan, South Korea, the Middle East, Africa, and Southeast Asia, enabling golfers to play the world's top 100 courses with confidence.</p>
                    <p>In 2025, we proudly announced renowned professional golfer <span class="font-bold">Sui-Xiang</span> as our <span class="font-bold">official brand ambassador,</span> further elevating our commitment to delivering world-class professional services.</p>
                    <p>Whether you are planning a golf trip to China or seeking to tee off at the finest courses around the globe, CHINA TEMA GOLF is your reliable partner for every swing.</p>
                    <p class="slogan font-bold">World Golf Journey · Starting From TEMA</p>
                    <p class="slogan font-bold">Click the link below to view the special travel packages for golfing in China</p>
                    <p class="slogan font-bold" style="color: rgb(64, 158, 255);" @click="toTemaGolfTravel">https://temagolftravel.com</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
    name: "HelloWorld",
    components: {
        swiper,
        swiperSlide,
    },
    data() {
        return {
            loading: true,
            caseList: [],
            newsList: [],
            swiperOption: {
                notNextTick: true,
                direction: "vertical",
                grabCursor: true,
                setWrapperSize: true,
                autoHeight: true,
                slidesPerView: 1,
                mousewheel: true,
                mousewheelControl: true,
                height: window.innerHeight - 115,
                resistanceRatio: 0,
                observeParents: true,
                on: {},
            },
            language: localStorage.getItem("lang") || "ZH"
        };
    },
    created() { },
    computed: {
        swiper() {
            return this.$refs.mySwiper.swiper;
        },
    },
    mounted() {
        this.loading = false;
    },
    methods: {
        toTemaGolfTravel() {
            window.open("https://temagolftravel.com/")
        }
    }
};
</script>

<style scoped>
.swiper-slide {
    font-size: 24px;
    text-align: center;
    display: flex;
    flex-direction: column;

    align-content: center;

    max-width: 1350px;
    overflow: hidden;
    margin: 0 auto;
}


/* productIntro 滚动区域 */
.productIntro {
    flex: 0 0 auto;
    max-width: 960px;
    width: 100%;
    max-height: 68vh;
    margin: 0 auto 12px;
    padding: 24px 48px;
    /* background: #fff; */
    border-radius: 12px;
    /* box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06); */
    text-align: left;
    overflow-y: auto;
    overflow-x: hidden;
    box-sizing: border-box;
    line-height: 1.7;
}

.productIntro h4 {
    margin: 0 0 16px 0;
    font-size: 10px;
    font-weight: 700;
    color: #1a1a1a;
    text-align: center;
    letter-spacing: 2px;
    padding-bottom: 12px;
    border-bottom: 1px solid #eee;
}

.productIntro p {
    margin: 0 0 10px 0;
    font-size: 1rem !important;
    color: #444;
    line-height: 1.5;
    text-indent: 2em;
    letter-spacing: 0;
}


/* productIntro 滚动条 */
.productIntro::-webkit-scrollbar {
    width: 4px;
}

.productIntro::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.15);
    border-radius: 2px;
}

.productIntro::-webkit-scrollbar-track {
    background: transparent;
}

@media screen and (max-width: 768px) {
    .swiper-slide {
        margin-top: 8px;
        height: calc(100vh - 8px);
    }

    .swiper-slide .page h3 {
        font-size: 1.6rem;
        letter-spacing: 0.4rem;
        margin-bottom: 10px;
    }

    .productIntro {
        max-height: 50vh;
        margin: 0 10px 10px;
        padding: 20px 16px;
    }

    .productIntro p {
        font-size: 12px;
        text-indent: 1.5em;
    }
}

/* 图片动画 */

.page5-tu1 {
    position: absolute;
    width: REM(480);
    height: REM(206);
    left: 23%;
    opacity: 1;
}

.page5-tu3 {
    position: absolute;
    width: REM(480);
    height: REM(206);
    left: 52%;
    opacity: 1;
}

.page5-tu1 {
    bottom: REM(778);
}

.page5-tu3 {
    bottom: REM(314);
}

.fadeout {
    -webkit-transition: all 7s;
    -moz-transition: all 7s;
    -ms-transition: all 7s;
    -o-transition: all 7s;
    transition: all 7s;
    opacity: 0;
}

.FadeInFrame {
    opacity: 0;
}

.FadeInFrame1 {
    display: none;
}

.FadeInFrame2 {
    display: block;
    opacity: 1;
}

.fadein {
    -webkit-transition: all 7s;
    -moz-transition: all 7s;
    -ms-transition: all 7s;
    -o-transition: all 7s;
    transition: all 7s;
    opacity: 1;
}
.font-bold{
    font-weight: 600 !important;
}
</style>